import { Injectable } from '@angular/core';
import { Resource } from '@df/catalog/resource';
import { IDay, IStoreData, IStoreDataV3, Store } from '@df/catalog/store/store';
import { isSameDay } from '@df/util/fn/is-same-day';
import { GMTDateToUK } from '@df/util/fn/uk-date';
declare module '@df/catalog/store/store' {
    export interface IStoreDataV1 {
        external_link?: string;
        allow_for_store_collect?: 1 | 0;
        images?: string[];
    }
}
export class LocalStore<T extends IStoreData = IStoreData> extends Store<T> {
    override get isOpenNow(): boolean {
        const hours = this.todayOpeningHours;
        if (!hours) {
            return false;
        }
        const date = new Date();
        GMTDateToUK(date);
        const h = (date.getUTCHours() + '').padStart(2, '0') + ':' + (date.getUTCMinutes() + '').padStart(2, '0');
        return hours?.status === 1 && hours.open <= h && hours.close > h;
    }
    override get isOpenToday(): boolean {
        const hours = this.todayOpeningHours;
        return !!hours && !!(hours.open && hours.open !== 'CLOSED');
    }
    private willBeOpenToday(day: IDay): boolean {
        if (day.status !== 1) {
            return false;
        }
        const date = new Date();
        GMTDateToUK(date);
        const h = (date.getUTCHours() + '').padStart(2, '0') + ':' + (date.getUTCMinutes() + '').padStart(2, '0');
        return day.open >= h;
    }
    get nextOpenDay(): IDay | undefined {
        return this.openingHours
            ?.sort((a: IDay, b: IDay) => (a.date?.getTime() || 0) - (b.date?.getTime() || 0))
            .find(day => {
                if (!day.holiday && day.status !== 2) {
                    if (isSameDay(day.date, new Date())) {
                        return this.willBeOpenToday(day);
                    }
                    return true;
                }
                return false;
            });
    }
    get isNextOpenDayToday(): boolean {
        if (this.nextOpenDay?.date) {
            return isSameDay(this.nextOpenDay.date, new Date());
        }
        return false;
    }
    get nextOpenDayName(): string {
        return this.nextOpenDay?.date?.toLocaleDateString('en-UK', { weekday: 'long' }) || '';
    }
    get url(): string | undefined {
        return (this.data?.url?.indexOf('warehouse') !== -1 && '/warehouses') || this.data?.external_link || this.data?.url;
    }
}
@Injectable()
export class LocalStoreResource extends Resource<LocalStore<IStoreDataV3>, number> {
    static override instance = LocalStore;
    readonly invalidatesUniversal = true;
    readonly invalidatesPrerender = true;
}
